export const getDisplayNameFromObject = (obj) => {
  if (!obj) return null;

  return (
    obj.worker_name ||
    obj.worker_full_name ||
    obj.user_full_name ||
    obj.full_name ||
    obj.name ||
    obj.user_name ||
    obj.username ||
    obj.email ||
    null
  );
};

export const getMmsMobileWorkerFromStorage = () => {
  try {
    if (typeof window === 'undefined' || !window?.localStorage) return null;
    const raw = window.localStorage.getItem('mms_mobile_user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};

export const getMmsActorName = (authUser) => {
  return (
    getDisplayNameFromObject(authUser) ||
    getDisplayNameFromObject(getMmsMobileWorkerFromStorage()) ||
    'Unknown User'
  );
};
